import { ref } from 'vue';
import { dataFetch } from '../helpers/dataFetch';
import type { StoreNavContent } from '../../store/content/navContent';

const contentData = ref<StoreNavContent>();
const eTagLocalStore = 'store-content-eTag';
const eTagExisting = sessionStorage.getItem(eTagLocalStore);

export const getContent = async (
  caasUrl,
  contentServiceUrl,
  project,
  instance,
  contentUUID,
  stage,
  locale,
  masterLocale,
  masterProject,
  prefix,
  storeId,
) => {
  const localeLowerCase = locale?.toLowerCase();

  const storedData = sessionStorage.getItem(storeId);

  const url = new URL(contentServiceUrl, caasUrl)
    .toString()
    .replace('{#project}', project)
    .replace('{#instance}', instance)
    .replace('{#contentUUID}', contentUUID)
    .replace('{#stage}', stage)
    .replace('{#locale}', localeLowerCase)
    .replace('{#masterLocale}', masterLocale)
    .replace('{#masterProject}', masterProject)
    .replace('{#prefix}', prefix || '');

  try {
    if (eTagExisting) {
      const response = await fetch(url, {
        headers: {
          'If-None-Match': eTagExisting,
        },
      });
      if (response.status === 304) {
        if (storedData) {
          const parsedData = JSON.parse(storedData);
          contentData.value = { items: parsedData.items satisfies StoreNavContent };
        }
      } else {
        if (!response.ok) {
          throw new Error(`${contentServiceUrl} >>> error, ${response.status}`);
        }

        const eTag = response.headers.get('Etag');

        if (eTag) {
          sessionStorage.setItem(eTagLocalStore, eTag);
        }

        contentData.value = await response.json();
        if (contentData.value && Object.keys(contentData.value).length) {
          sessionStorage.setItem(storeId, JSON.stringify({ items: contentData.value }));
        }
        console.debug(`${contentServiceUrl} >>> initialized`, contentData.value);
      }
    } else {
      const { data, eTag } = await dataFetch(url);
      if (eTag) {
        sessionStorage.setItem(eTagLocalStore, eTag);
      }
      contentData.value = data;
      sessionStorage.setItem(
        storeId,
        JSON.stringify({
          items: contentData.value,
        }),
      );
    }
    return contentData.value;
  } catch (error) {
    console.error(`${contentServiceUrl} >>> error`, error);
  }
};
